<template>
  <nd-dialog
    v-model="visible"
    close-btn
    :footer="false"
    title="温馨提示"
  >
    <div class="pay-content">
      <div class="pay-info">

        <template v-if="consumptionRepayPop">
          <div v-html="consumptionRepayPop"> </div>
        </template>
        <template v-else>
          该笔还款账单已关联消费账单，请先支付消费账单「我的-我的账单-消费账单」
        </template>
      </div>
      <nd-button
        class="pay-btn"
        @click="handleToPay"
      >去支付</nd-button>
    </div>
  </nd-dialog>
</template>

<script>
export default {
  name: 'vvipIntroDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    repayBillNo: {
      type: String,
      default: ''
    },
    consumptionRepayPop: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    // 跳转去支付
    handleToPay () {
      this.$router.push(`/repayment/detail-expense?repayBillNo=${this.repayBillNo}`)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.pay-content{
  padding: 30px 50px;
  text-align: left;
  .pay-info{
    font-size: 28px;
    /deep/p {
      margin-bottom: 10px;
      position: relative;
      padding-left: 20px;
      &:after{
        content: "";
        position: absolute;
        left:0;
        font-size: 30px;
        top:0
      }
    }
  }
  .pay-btn{
    width: 100%;
    margin-top: 100px;
  }
}
</style>